import { createClient } from 'graphqurl';
import { getVariableOrDefault } from './utils/env';
import { extractAgencyFromUrl } from './utils/url';

const defaultAgencyProvider = () => {
  return extractAgencyFromUrl(window.location.hostname) || 'default';
};

const endpoint = getVariableOrDefault(
  'VUE_APP_THEME_SERVICE_URL',
  'https://c360-be.stg.adportal.io/graphql',
);

const alertsQuery = `
  query ($product: String!, $agency: String!, $url: String!) {
    alerts(product: $product, active: true, agency: $agency, url: $url) {
      id
      title
      color
      message
      icon
      dismissible
    }
  }
`;

export const loadAlerts = async (product, url) => {
  const agency = defaultAgencyProvider();

  const gqlClient = createClient({
    endpoint,
    headers: {
      'content-type': 'application/json',
    },
  });

  try {
    const { data } = await gqlClient.query({
      query: alertsQuery,
      variables: { product, agency, url },
    });
    return data.alerts;
  } catch (error) {
    console.error(error);
    return [];
  }
};
